export default {
  goal: {
    title: 'Goal',
    fromStudy:
      'Prefilled from the study. Results describe the source version, not this draft.',
    atDp: 'at {{dp}}',
  },
  files: {
    draftRow: 'draft · unsaved',
    draftLoading: 'loading…',
    draftRevision: 'rev {{revision}}',
  },
  viewer: {
    draft: 'Draft',
    source: 'Source',
    unsavedDraft: 'Unsaved draft rev {{revision}}',
    loadingDraft: 'Loading draft…',
    updating: 'updating…',
    earlierRevision: 'showing an earlier revision',
    draftUnavailable: 'Draft preview unavailable: {{message}}',
    draftExpired: 'Draft preview expired or is no longer available.',
    draftClosed: 'Draft discarded or session no longer available.',
    notSimulated:
      'Draft rev {{revision}} has not been simulated — every result here belongs to v{{version}}.',
  },
  advisor: {
    discardDraft: 'Discard draft',
  },
  draftHealth: {
    title: 'Draft health',
    sessionChecks: 'Session checks',
    sessionChecksHint:
      "What the assistant's own checks said when it built this revision.",
    checksPending: "Waiting for the assistant's checks on this revision.",
    checksPassed: 'Passed on rev {{revision}}',
    checksPassedBody:
      'The edit ran and produced a solid. This is not a meshing verdict.',
    checksFailed: 'Failed on rev {{revision}}',
    topology: 'Topology',
    topologyUnavailable: 'No topology check for this revision.',
    topologyPending: 'Checking the topology of this revision…',
    topologyFailed: 'Topology check did not finish',
    topologyFailedBody:
      'The draft can still be reviewed and saved; the saved version is diagnosed as usual.',
    review: 'Review & save as v{{version}}',
  },
  review: {
    pair: 'v{{version}} source ↔ draft rev {{revision}}',
    notValidated: 'Not yet validated',
    notValidatedBody:
      'Every pressure, temperature and force figure in this workspace belongs to v{{version}}. This draft has never been simulated.',
    summaryPlaceholder:
      'What changed and what it targets — e.g. “Ports Ø12 → Ø14, ribs 6 → 4, targeting ΔP ≤ 15 kPa.”',
    eyebrow: 'CadMorph draft',
    title: 'Review draft rev {{revision}}',
    summaryLabel: 'What changed',
    healthTitle: 'Health',
    metricsTitle: 'Geometry',
    blocking: 'Blocking issues',
    quality: 'Quality issues',
    notChecked: 'Not yet checked',
    checkFailed: 'Check failed',
    topologyFailed: 'Topology check: {{message}}',
    passed: 'Passed',
    failed: 'Failed',
    reject: 'Reject',
    approve: 'Approve & save as v{{version}}',
    approvalNote:
      'The assistant asks you to approve the save in chat before anything is written.',
    back: 'Back to draft health',
  },
} as const;
